<template>
    <div class="error-page">
        <div class="container">
           <div class="img p-center">
               <img src="/img/404.svg" alt="">
           </div>
            <div class="content">
                <h1 class="relawayBold p-black p-center p-title"><b>Oops! Page not found...</b></h1>
                <p class="Raleway p-center min-med">You should try to refresh this page or return to the Home page</p>
            </div>
            <div class="btns">
                <div class="row justify-content-center">
                    <div class="col-md-5">
                        <router-link :to="{name: 'index'}" :class="'btn btn-green btn-full small'">
                            to main
                        </router-link>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NotFoundPage",
    }
</script>
